import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { logoutAction } from "../actions/authActions";
import UserPanel from "../components/UserPanel";
import Image from "../components/Image";
import ChangePassword from "../components/ChangePassword";
import { getCurrentUserData } from "../actions/authActions";
import { validatePhoneNumber } from "../validations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faArrowRightFromBracket,
  faCamera,
  faChevronRight,
  faPlusCircle,
  faPlusSquare,
  faSquarePlus,
  faPlus,
  faBoxesStacked,
  faUser,
  faLocationDot,
  faHeart,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

const UserPanelPage = ({ userData, logoutAction }) => {
  const [previewImage, setPreviewImage] = useState();

  const { t } = useTranslation();

  const renderProfileIMG = () => {
    if (previewImage) {
      return <img src={previewImage} alt="User Photo" />;
    } else if (userData && userData.profile_pic) {
      return <img src={userData.profile_pic} alt="User Photo" />;
    }
    return null;
  };

  return (
    <div className="userpanel-page-for-mobile">
      <Image
        src={userData?.profile_pic}
        imgClassName="userpanel-page-for-mobile-user-photo"
        alt="User Photo"
      />

      <h3>
        {userData?.first_name} {userData?.last_name}
      </h3>

      <ul>
        {/* <li>
          <Link to="/add/new/post">
            <FontAwesomeIcon icon={faPlusSquare} /> {t("Add post")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li> */}

        {/* <li>
          <Link to="/active/posts">
            <FontAwesomeIcon icon={faBoxesStacked} /> {t("Active Posts")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li> */}

        <li>
          <Link to="/me">
            <FontAwesomeIcon icon={faUser} />
            {t("My Profile")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li>

        <li>
          <Link to="/generateqr">
            <FontAwesomeIcon icon={faLocationDot} />
            {t("my tags")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li>

        {/* <li>
          <Link to="/favorite">
            <FontAwesomeIcon icon={faHeart} />
            {t("Favorite")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li> */}

        <li>
          <Link to="/messages">
            <FontAwesomeIcon icon={faPaperPlane} />
            {t("Messages")}
          </Link>
          <FontAwesomeIcon icon={faAngleRight} />
        </li>

        <li>
          <Link onClick={() => logoutAction()}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
            {t("logout")}
          </Link>
        </li>
      </ul>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData.userData,
    serverErrors: state.errors.errors,
  };
};

export default connect(mapStateToProps, {
  getCurrentUserData,
  logoutAction,
})(UserPanelPage);
